export enum MemberStatusEnum {
  Yes = 1,
  No = 0,
}
export enum MemberNameStatusEnum {
  Yes = '1',
  No = '0',
}

export enum MemberGenderEnum {
  Unknown = 0,
  Male = 1,
  Female = 2,
}
